<template>
  <!-- 轨迹详情地图 -->
  <div class="maps">
    <div id="riding-map"></div>
  </div>
</template>

<script>
import start from "../../../../assets/images/start.png";
import cart from "../../../../assets/images/cart.png";
import { mapState } from "vuex";
export default {
  data() {
    return {
      map: null,
      startMarker: null,
      endMarker: null,
      flightPath: null,
      center: [120.373237, 31.475957],
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {
    dialogVisible: {
      deep: true, //深度监听设置为 true
      handler(val) {
        let arr = this.regionList;
        if (!val) {
          // console.log(this.trackData);
          let that = this;
          if (arr[this.currentRegion].id != "cn") {
            this.startMarker.setMap(null);
            this.endMarker.setMap(null);
            this.flightPath.setMap(null);
          } else {
            this.map.remove(that.startMarker);
            this.map.remove(that.flightPath);
            this.map.remove(that.endMarker);
          }
        } else {
          console.log(this.trackData);
          if (arr[this.currentRegion].id != "cn") {
            this.setGoogleMarker(
              new google.maps.LatLng({
                lat: this.trackData[0][1],
                lng: this.trackData[0][0],
              }),
              new google.maps.LatLng({
                lat: this.trackData[this.trackData.length - 1][1],
                lng: this.trackData[this.trackData.length - 1][0],
              })
            );
            let arr = [];
            for (let i in this.trackData) {
              arr.push(
                new google.maps.LatLng({
                  lat: this.trackData[i][1],
                  lng: this.trackData[i][0],
                })                                                                                                                                                                                                                                                                                                                                                                
              );
            }
            this.setGoogleFilght(arr);
          } else {
            this.setCnMapMarker(
              this.trackData[0],
              this.trackData[this.trackData.length - 1]
            );
            this.setCnMapFlight(this.trackData);
          }
        }
      },
    },
  },
  props: ["trackData", "dialogVisible"],
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  methods: {
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
        this.setGoogleMarker(
          new google.maps.LatLng({
            lat: this.trackData[0][1],                                                
            lng: this.trackData[0][0],
          }),
          new google.maps.LatLng({
            lat: this.trackData[this.trackData.length - 1][1],
            lng: this.trackData[this.trackData.length - 1][0],
          })
        );
        let arr = [];
        for (let i in this.trackData) {
          arr.push(
            new google.maps.LatLng({
              lat: this.trackData[i][1],
              lng: this.trackData[i][0],
            })
          );
        }
        this.setGoogleFilght(arr);
      } else {
        this.initCnMap();
        this.setCnMapMarker(
          this.trackData[0],
          this.trackData[this.trackData.length - 1]
        );
        this.setCnMapFlight(this.trackData);
      }
    },
    //google地图
    initGoogleMap() {
      this.map = new google.maps.Map(document.getElementById("riding-map"), {
        mapId: "1dac188ecae44d48",
        zoom: 15,
        center: new google.maps.LatLng({
          lat: this.trackData[this.trackData.length - 1][1],
          lng: this.trackData[this.trackData.length - 1][0],
        }),
        disableDefaultUI: true,
      });
    },
    //google地图marker
    setGoogleMarker(startLatLng, endLatLng) {
      if (this.startMarker && this.endMarker) {
        this.startMarker.setMap(null);
        this.endMarker.setMap(null);
      }
      this.startMarker = new google.maps.Marker({
        position: startLatLng,
        icon: start,
      });
      this.endMarker = new google.maps.Marker({
        position: endLatLng,
        icon: cart,
      });
      this.startMarker.setMap(this.map);
      this.endMarker.setMap(this.map);
    },
    //设置谷歌地图轨迹
    setGoogleFilght(paths) {
      // console.log(paths);
      if (this.flightPath) {
        this.flightPath.setMap(null);
      }
      this.flightPath = new google.maps.Polyline({
        path: paths,
        geodesic: true,
        strokeColor: "#FFAE0C",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
      this.flightPath.setMap(this.map);
    },
    //高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("riding-map", {
        resizeEnable: true,
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        center: that.center,
        zoom: 15,
      });
    },
    //设置高德地图点标记
    setCnMapMarker(startLatLng, endLatLng) {
      let that = this;
      if (this.startMarker && this.endMarker) {
        this.map.remove(that.endMarker);
        this.map.remove(that.startMarker);
      }
      this.startMarker = new AMap.Marker({
        position: startLatLng,
        icon: start,
        map: that.map,
      });

      this.endMarker = new AMap.Marker({
        position: endLatLng,
        icon: cart,
        map: that.map,
      });
      this.map.setFitView([that.startMarker, that.endMarker]);
    },
    //设置高德地图轨迹
    setCnMapFlight(paths) {
      let that = this;
      if (this.flightPath) {
        this.map.remove(that.flightPath);
      }
      this.flightPath = new AMap.Polyline({
        path: paths,
        isOutline: true,
        outlineColor: "#ffeeee",
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: "#FFAE0C",
        lineJoin: "round",
        strokeStyle: "dashed",
      });
      this.flightPath.setMap(that.map);
    },
  },
};
</script>


<style scoped>
.maps {
  width: 100%;
  height: 100%;
}
#riding-map {
  width: 100%;
  height: 100%;
}
</style>